/* Ondudes: elementy konwersji na stronie produktu. Tylko wyświetlanie, nie zmienia cen ani wariantów.
   Zmiany nakładane są synchronicznie w MutationObserver, przed odświeżeniem ekranu, więc po przerysowaniu przez motyw nic nie mruga. */
(function () {
  if (window.__onduBoost) return;
  window.__onduBoost = true;

  var dataEl = document.querySelector('[data-ondu-variants]');
  if (!dataEl) return;
  var cfg;
  try { cfg = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var variants = cfg.variants || [];
  var stickyBar = null;
  var subDefaultDone = false;
  var byId = {};
  variants.forEach(function (v) { byId[String(v.id)] = v; });

  function zl(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' zł'; }
  function leadingNumber(str) { var m = String(str).match(/\d+/); return m ? parseInt(m[0], 10) : NaN; }
  function norm(s) { return String(s || '').trim().toLowerCase(); }
  function root() { return document.querySelector('.product-information') || document; }
  function setText(el, txt) { if (el && el.textContent !== txt) el.textContent = txt; }
  function optionIndex(name) {
    var sets = root().querySelectorAll('variant-picker fieldset');
    for (var i = 0; i < sets.length; i++) {
      var lg = sets[i].querySelector('legend');
      if (lg && norm(lg.textContent).indexOf(norm(name)) === 0) return i;
    }
    return -1;
  }
  function optionFieldset(name) {
    var i = optionIndex(name);
    return i < 0 ? null : root().querySelectorAll('variant-picker fieldset')[i];
  }

  /* Etykiety i oszczędność (albo cena za parę) na przyciskach ilości */
  function decoratePacks() {
    var idx = optionIndex(cfg.packOption);
    var fs = optionFieldset(cfg.packOption);
    if (!fs || idx < 0) return;
    if (!fs.classList.contains('ondu-packs')) fs.classList.add('ondu-packs');
    var minByValue = {};
    variants.forEach(function (v) {
      var val = v.options[idx];
      if (minByValue[val] === undefined || v.price < minByValue[val]) minByValue[val] = v.price;
    });
    var perPair = {}, basePair = null, bestPair = null, singlePair = null;
    Object.keys(minByValue).forEach(function (val) {
      var n = leadingNumber(val);
      if (!n) return;
      perPair[val] = minByValue[val] / n;
      if (n === 1) singlePair = minByValue[val];
      if (basePair === null || perPair[val] > basePair) basePair = perPair[val];
      if (bestPair === null || perPair[val] < bestPair) bestPair = perPair[val];
    });
    var refPair = singlePair !== null ? singlePair : basePair;
    fs.querySelectorAll('label').forEach(function (label) {
      var input = label.querySelector('input');
      if (!input || label.getAttribute('data-ondu-done')) return;
      label.setAttribute('data-ondu-done', '1');
      var val = input.value;
      if (perPair[val] === undefined) return;
      var off = basePair ? Math.round((1 - perPair[val] / basePair) * 100) : 0;
      var n = leadingNumber(val);
      var save = refPair !== null ? refPair * n - minByValue[val] : 0;
      if (cfg.showPerPair) {
        var el = document.createElement('span');
        el.className = 'ondu-pair';
        el.innerHTML = zl(Math.round(perPair[val])) + '/para' + (off >= 1 ? ' <b>−' + off + '%</b>' : '');
        label.appendChild(el);
      } else if (n > 1 && save >= 100) {
        /* Oszczędność względem kupowania pojedynczych par; pokazywana od 1 zł */
        var sv = document.createElement('span');
        sv.className = 'ondu-pair';
        sv.innerHTML = 'Oszczędzasz <b>' + zl(Math.round(save)) + '</b>';
        label.appendChild(sv);
      }
      var tag = '';
      if (cfg.popular && norm(val) === norm(cfg.popular) && cfg.popularLabel) tag = cfg.popularLabel;
      else if (cfg.bestLabel && off >= 1 && perPair[val] === bestPair) tag = cfg.bestLabel;
      if (tag) {
        var t = document.createElement('span');
        t.className = 'ondu-tag';
        t.textContent = tag;
        label.appendChild(t);
      }
    });
  }

  /* Rozmiary w kolejności rosnącej (tylko wyświetlanie) */
  function sortSizes() {
    var fs = optionFieldset(cfg.sizeOption);
    if (!fs) return;
    var labels = Array.prototype.slice.call(fs.querySelectorAll(':scope > label'));
    if (labels.length < 2) return;
    var sorted = labels.slice().sort(function (a, b) { return leadingNumber(a.textContent) - leadingNumber(b.textContent); });
    if (sorted.every(function (l, i) { return l === labels[i]; })) return;
    var anchor = labels[labels.length - 1].nextSibling;
    sorted.forEach(function (l) { fs.insertBefore(l, anchor); });
  }

  /* Abonament (Appstle): lista korzyści i częstotliwość jako przyciski */
  function subOption() {
    var w = root().querySelector('.appstle_sub_widget');
    if (!w) return null;
    return w.querySelector('.appstle_subscription_wrapper_option.appstle_include_dropdown') ||
      (w.querySelector('.appstle_subscription_radio_wrapper') || {}).parentElement || null;
  }
  function styleSubscription() {
    var subOpt = subOption();
    if (!subOpt) return;
    if (cfg.subBullets && cfg.subBullets.length && !subOpt.querySelector('.ondu-sub-bullets')) {
      var ul = document.createElement('ul');
      ul.className = 'ondu-sub-bullets';
      cfg.subBullets.forEach(function (b) {
        b = String(b || '').trim();
        if (!b) return;
        var li = document.createElement('li');
        li.textContent = b;
        ul.appendChild(li);
      });
      var anchor = subOpt.querySelector('.appstle_subscription_radio_wrapper');
      if (anchor && anchor.nextSibling) subOpt.insertBefore(ul, anchor.nextSibling);
      else subOpt.appendChild(ul);
    }
    var select = subOpt.querySelector('select.appstle_select');
    if (select && select.options.length > 1) {
      var grid = select.closest('.appstle_subscribe_option_grid') || select.parentElement;
      var chips = grid.querySelector('.ondu-freq');
      if (!chips) {
        chips = document.createElement('div');
        chips.className = 'ondu-freq';
        chips.setAttribute('role', 'radiogroup');
        Array.prototype.forEach.call(select.options, function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'ondu-freq__chip';
          b.setAttribute('role', 'radio');
          b.dataset.value = o.value;
          b.textContent = o.textContent.trim();
          b.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            select.value = o.value;
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            run();
          });
          chips.appendChild(b);
        });
        grid.appendChild(chips);
      }
      chips.querySelectorAll('.ondu-freq__chip').forEach(function (b) {
        var on = String(b.dataset.value === select.value);
        if (b.getAttribute('aria-checked') !== on) b.setAttribute('aria-checked', on);
      });
    }
    if (cfg.subDefault && !subDefaultDone) {
      var radio = subOpt.querySelector('input[type="radio"]');
      if (radio) { subDefaultDone = true; if (!radio.checked) radio.click(); }
    }
  }

  function currentVariant() {
    var input = root().querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    return input ? byId[String(input.value)] : null;
  }

  /* Cena wybranej opcji: przy abonamencie cena z Appstle, w innym wypadku cena wariantu */
  function currentPriceText(v) {
    var subOpt = subOption();
    var radio = subOpt && subOpt.querySelector('input[type="radio"]');
    if (radio && radio.checked) {
      var amt = subOpt.querySelector('.appstle_subscription_amount');
      if (amt && amt.textContent.trim()) return amt.textContent.trim();
    }
    return v ? zl(v.price) : '';
  }

  /* Pasek darmowej wysyłki i przyklejona belka */
  function updateShippingAndSticky() {
    var v = currentVariant();
    var box = document.querySelector('[data-ondu-ship]');
    if (box && cfg.threshold && v && box.getAttribute('data-ondu-for') !== String(v.id)) {
      box.setAttribute('data-ondu-for', String(v.id));
      var text = box.querySelector('[data-ondu-ship-text]');
      var bar = box.querySelector('[data-ondu-ship-bar]');
      box.hidden = false;
      if (v.price >= cfg.threshold) {
        box.classList.add('is-done');
        text.innerHTML = '<b>Masz darmową wysyłkę</b> przy tym zamówieniu';
        bar.style.width = '100%';
      } else {
        box.classList.remove('is-done');
        text.innerHTML = 'Brakuje Ci <b>' + zl(cfg.threshold - v.price) + '</b> do darmowej wysyłki';
        bar.style.width = Math.max(4, Math.min(100, v.price / cfg.threshold * 100)) + '%';
      }
    }
    if (stickyBar && v) {
      setText(stickyBar.querySelector('[data-ondu-sticky-variant]'), v.title);
      setText(stickyBar.querySelector('[data-ondu-sticky-price]'), currentPriceText(v));
    }
  }

  /* Termin wysyłki: zamówienia do godziny granicznej nadajemy w następny dzień roboczy */
  function updateDelivery() {
    var el = document.querySelector('[data-ondu-delivery]');
    if (!el) return;
    var now = new Date();
    var cutoff = new Date(now); cutoff.setHours(cfg.cutoff, 0, 0, 0);
    var dow = now.getDay();
    var html;
    if (dow < 1 || dow > 5 || now >= cutoff) {
      html = 'Zamów teraz, a paczkę nadamy w <b>najbliższy dzień roboczy</b>. Paczkomat lub kurier.';
    } else {
      var mins = Math.floor((cutoff - now) / 60000);
      var h = Math.floor(mins / 60), m = mins % 60;
      var next = dow === 5 ? 'w poniedziałek' : 'jutro';
      html = 'Zamów w ciągu <b>' + (h ? h + ' h ' : '') + m + ' min</b>, a nadamy paczkę <b>' + next + '</b>. Paczkomat lub kurier.';
    }
    if (el.innerHTML !== html) el.innerHTML = html;
  }

  /* Przyklejony przycisk na telefonie: klika prawdziwy przycisk, więc abonament i warianty działają jak dotąd */
  function setupSticky() {
    var bar = document.querySelector('[data-ondu-sticky]');
    var btn = bar && bar.querySelector('[data-ondu-sticky-btn]');
    if (!bar || !btn || !('IntersectionObserver' in window)) return;
    function realButton() {
      return root().querySelector('form[data-type="add-to-cart-form"] [name="add"], form[data-type="add-to-cart-form"] button[type="submit"]');
    }
    var target = realButton() || root().querySelector('.buy-buttons-block');
    if (!target) return;
    document.body.appendChild(bar);
    stickyBar = bar;
    var footerVisible = false, targetVisible = true;
    function sync() {
      var show = !targetVisible && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      btn.tabIndex = show ? 0 : -1;
    }
    var io = new IntersectionObserver(function (entries) { targetVisible = entries[0].isIntersecting; sync(); });
    io.observe(target);
    var footer = document.querySelector('footer, .shopify-section-group-footer-group');
    if (footer) {
      new IntersectionObserver(function (entries) { footerVisible = entries[0].isIntersecting; sync(); }).observe(footer);
    }
    setInterval(function () {
      var now = realButton();
      if (now && now !== target) { io.unobserve(target); target = now; io.observe(target); }
    }, 1500);
    btn.addEventListener('click', function () {
      var real = realButton();
      if (real && !real.disabled) real.click();
      else if (target.scrollIntoView) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  var running = false;
  function run() {
    if (running) return;
    running = true;
    try { decoratePacks(); } catch (e) {}
    try { sortSizes(); } catch (e) {}
    try { styleSubscription(); } catch (e) {}
    try { updateShippingAndSticky(); } catch (e) {}
    running = false;
  }

  function init() {
    setupSticky();
    run();
    updateDelivery();
    setInterval(updateDelivery, 30000);
    var r = root();
    if ('MutationObserver' in window) {
      /* Synchronicznie, przed malowaniem klatki: brak mrugania po przerysowaniu */
      new MutationObserver(run).observe(r === document ? document.body : r, { childList: true, subtree: true });
    }
    document.addEventListener('change', function () { run(); setTimeout(run, 150); });
    document.addEventListener('variant:update', run);
    var tries = 0;
    var poll = setInterval(function () { run(); if (++tries > 20) clearInterval(poll); }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
